// extracted by mini-css-extract-plugin
export var container = "HeaderGatewayMenu-module--container--199fe";
export var currentGateway = "HeaderGatewayMenu-module--currentGateway--b17b9";
export var gatewayCity = "HeaderGatewayMenu-module--gatewayCity--576c7";
export var gatewayCityContainer = "HeaderGatewayMenu-module--gatewayCityContainer--7f805";
export var gatewayContainer = "HeaderGatewayMenu-module--gatewayContainer--1b02a";
export var menu = "HeaderGatewayMenu-module--menu--f38b0";
export var menuOpen = "HeaderGatewayMenu-module--menuOpen--09fd4";
export var province = "HeaderGatewayMenu-module--province--ca5b5";
export var provinceLabel = "HeaderGatewayMenu-module--provinceLabel--61c26";